import { render, staticRenderFns } from "./DietSettings.vue?vue&type=template&id=215c300e&scoped=true&"
import script from "./DietSettings.vue?vue&type=script&lang=js&"
export * from "./DietSettings.vue?vue&type=script&lang=js&"
import style0 from "./DietSettings.vue?vue&type=style&index=0&id=215c300e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c300e",
  null
  
)

export default component.exports